import { FormCollapse, Tile, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AdvisorsResourceInfo } from '../AdvisorsResource/AdvisorsResource';
import { Advisors } from '../../../interfaces/Advisors';
import Content from './Content';

export interface AdvisorsTileProps { }

const AdvisorsTile: FC<AdvisorsTileProps> = () => {
  const { t } = useTranslation('ContactUsPage');
  const advisors: Advisors = useScopedSelector(AdvisorsResourceInfo.dataDst);

  if (!advisors || advisors?.advisors?.length === 0) {
    return null;
  }

  return (
    <Tile data-testid="advisorsTile" titleAs="h2" title={t('advisorsTitle')}>
      {advisors?.advisors?.map((a) => (
        <FormCollapse key={a.id} title={a.fullName}>
          <Content advisor={a} />
        </FormCollapse>
      ))}
    </Tile>

  );
};

export default AdvisorsTile;
